// Shared by the lender bid forms and admin's "change paid out offer" modal, so
// the copy cannot drift between the two surfaces that write the same field.
// Kept as an English literal — neither the lender portal nor admin is localised.
//
// Lives apart from TotalCostTooltip so the yup validator can quote the label
// without transitively importing React components into a schema-only module.
export const totalCostLabelText =
  "Total cost (inc. all fees and approved amount)";
